<template>
      <header class="navbar sticky-top bg-dark flex-md-nowrap p-0 shadow" data-bs-theme="dark">
        <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white" href="#">Company name</a>
<!--
        <ul class="navbar-nav flex-row d-md-none">
          <li class="nav-item text-nowrap">
            <button class="nav-link px-3 text-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSearch" aria-controls="navbarSearch" aria-expanded="false" aria-label="Toggle search">
              <svg class="bi"><use xlink:href="#search"/></svg>
            </button>
          </li>
          <li class="nav-item text-nowrap">
            <button class="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
              <svg class="bi"><use xlink:href="#list"/></svg>
            </button>
          </li>
        </ul>
        <div id="navbarSearch" class="navbar-search w-100 collapse">
          <input class="form-control w-100 rounded-0 border-0" type="text" placeholder="Search" aria-label="Search">
        </div>
-->
      </header>
      <div class="container-fluid">
        <div class="row">
          <div class="sidebar border border-right col-md-3 col-lg-2 p-0 bg-body-tertiary">
            <div class="offcanvas-lg offcanvas-end bg-body-tertiary" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="sidebarMenuLabel">Company name</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
              </div>
              <div class="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2 active" aria-current="page" href="#">
                      <svg class="bi"><use xlink:href="#house-fill"/></svg>
                      Dashboard
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#file-earmark"/></svg>
                      Orders
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#cart"/></svg>
                      Products
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#people"/></svg>
                      Customers
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#graph-up"/></svg>
                      Reports
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#puzzle"/></svg>
                      Integrations
                    </a>
                  </li>
                </ul>
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-body-secondary text-uppercase">
                  <span>Saved reports</span>
                  <a class="link-secondary" href="#" aria-label="Add a new report">
                    <svg class="bi"><use xlink:href="#plus-circle"/></svg>
                  </a>
                </h6>
                <ul class="nav flex-column mb-auto">
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#file-earmark-text"/></svg>
                      Current month
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#file-earmark-text"/></svg>
                      Last quarter
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#file-earmark-text"/></svg>
                      Social engagement
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#file-earmark-text"/></svg>
                      Year-end sale
                    </a>
                  </li>
                </ul>
                <hr class="my-3">
                <ul class="nav flex-column mb-auto">
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#gear-wide-connected"/></svg>
                      Settings
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link d-flex align-items-center gap-2" href="#">
                      <svg class="bi"><use xlink:href="#door-closed"/></svg>
                      Sign out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 class="h2">{{ msg }}</h1>
            </div>
            <h2>Section title</h2>
            <div class="table-responsive small">
              <table class="table table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">No</th>
                    <th scope="col">User Name</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(page) in pages.data" v-bind:key="page.id">
                    <td>{{ page.id }}</td>
                    <td>{{ page.username }}</td>
                    <td>{{ page.firstName }}</td>
                    <td>{{ page.lastName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </main>
        </div>
      </div>
</template>

<script>
export default {
  name: 'AppTop',
  props: {
    msg: String
  },
  data() {
    return {
      pages: []
    };
  },
  async mounted() {
    const response = await fetch('/api/pages');
    this.pages = await response.json();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bi {
    display: inline-block;
    width: 1rem;
    height: 1rem;
  }

  /*
  * Sidebar
  */

  @media (min-width: 768px) {
    .sidebar .offcanvas-lg {
      position: -webkit-sticky;
      position: sticky;
      top: 48px;
    }
    .navbar-search {
      display: block;
    }
  }

  .sidebar .nav-link {
    font-size: .875rem;
    font-weight: 500;
  }

  .sidebar .nav-link.active {
    color: #2470dc;
  }

  .sidebar-heading {
    font-size: .75rem;
  }

  /*
  * Navbar
  */

  .navbar-brand {
    padding-top: .75rem;
    padding-bottom: .75rem;
    background-color: rgba(0, 0, 0, .25);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
  }

  .navbar .form-control {
    padding: .75rem 1rem;
  }
</style>
